import { Card as CardBase, CardProps, Space } from "antd";
import styled from "styled-components";
import * as styles from "../InventoryTransferIndexPage/styles";
import colors from "@secondcloset/web-components/dist/styles/colors";
import { Flex } from "css/styles";
export const PageHeader = styles.PageHeader;

export const Container = styled(Space)`
  width: 100%;
`;

export const Card = styled(CardBase)<CardProps>`
  .ant-card-body {
    padding: ${({ size }) => (size === "small" ? "0px" : "24px")};
  }
  .padded {
    padding: 24px;
    border-bottom: 1px solid rgba(0, 0, 0, 0.06);
    gap: 26px;
  }
`;

export const TimelineContainer = styled(Flex)`
  ul,
  .ant-page-header,
  .ant-card {
    width: 100%;
  }

  .ant-timeline-item-last {
    padding-bottom: 0px;
    .ant-timeline-item-head-blue {
      background-color: ${colors.PRIMARY};
    }
    .ant-timeline-item-content {
      min-height: unset;
    }
  }
  .ant-divider-horizontal {
    margin: 0 0 24 0;
  }
`;
